import { addSheetBackLink, PARENT_SHEETS } from "../sheetNavigation";
import {
  COL_D,
  COL_E,
  COL_F,
  COL_G,
  COL_H,
  COL_I,
  DATA_START_ROW,
  HEADER_FILL,
  HEADER_ROW,
  TABLE_HEADER_FILL,
  TITLE_ROW,
} from "./principle1DetailHelpers";

const THIN_BLACK = {
  top: { style: "thin", color: { argb: "FF000000" } },
  left: { style: "thin", color: { argb: "FF000000" } },
  bottom: { style: "thin", color: { argb: "FF000000" } },
  right: { style: "thin", color: { argb: "FF000000" } },
};

const BODY_FONT = { name: "Calibri", size: 11 };
const COL_J = 10;
const COL_K = 11;

const SHEET_TITLE =
  "The entity conducted Life Cycle Perspective/Assessments (LCA)";

export const SHEET_NAME = "Life cycle assessment";

const HEADERS = [
  { col: COL_D, label: "Sr. No.", width: 8 },
  { col: COL_E, label: "NIC Code", width: 12 },
  { col: COL_F, label: "Name of Product/Service", width: 18 },
  { col: COL_G, label: "% of total Turnover contributed", width: 14 },
  {
    col: COL_H,
    label: "Boundary for which the Life Cycle Perspective/Assessment was conducted",
    width: 22,
  },
  {
    col: COL_I,
    label: "Whether conducted by independent external agency (Yes/No)",
    width: 16,
  },
  {
    col: COL_J,
    label: "Results communicated in public domain (Yes/No)",
    width: 16,
  },
  { col: COL_K, label: "If yes, provide the web-link.", width: 18 },
];

function borderCell(cell) {
  cell.border = THIN_BLACK;
}

function setCell(ws, row, col, value, options = {}) {
  const cell = ws.getCell(row, col);
  cell.value = value;
  cell.font = options.bold ? { ...BODY_FONT, bold: true } : BODY_FONT;
  borderCell(cell);
  cell.alignment = {
    horizontal: options.align || "center",
    vertical: options.vertical || "middle",
    wrapText: true,
  };
  if (options.fill) cell.fill = options.fill;
}

function toYesNo(value) {
  if (value === true || value === "true" || value === "yes" || value === "Yes") return "Yes";
  if (value === false || value === "false" || value === "no" || value === "No") return "No";
  return "-";
}

function formatPercent(value) {
  if (value === null || value === undefined || value === "") return "-";
  const str = String(value);
  return str.includes("%") ? str : `${str}%`;
}

function setColumnWidths(ws) {
  const widths = { A: 2, B: 2, C: 2 };
  HEADERS.forEach(({ col, width }) => {
    widths[String.fromCharCode(64 + col)] = width;
  });
  Object.entries(widths).forEach(([col, width]) => {
    ws.getColumn(col).width = width;
  });
}

export function buildLifeCycleAssessmentSheet(workbook, sectionC) {
  const ws = workbook.addWorksheet(SHEET_NAME, { views: [{ showGridLines: true }] });
  setColumnWidths(ws);
  addSheetBackLink(ws, PARENT_SHEETS.PRINCIPLE_2, { mergeEnd: COL_K });

  ws.mergeCells(TITLE_ROW, COL_D, TITLE_ROW, COL_K);
  setCell(ws, TITLE_ROW, COL_D, SHEET_TITLE, {
    bold: true,
    fill: HEADER_FILL,
    align: "center",
  });

  HEADERS.forEach(({ col, label }) => {
    setCell(ws, HEADER_ROW, col, label, {
      bold: true,
      fill: TABLE_HEADER_FILL,
      align: "center",
    });
  });

  const rows = Array.isArray(
    sectionC?.principle2?.leadershipIndicator?.lifeCycleAssessments?.assessments
  )
    ? sectionC.principle2.leadershipIndicator.lifeCycleAssessments.assessments
    : [];
  const dataRows = rows.length ? rows : [{}];

  dataRows.forEach((item, idx) => {
    const row = DATA_START_ROW + idx;
    setCell(ws, row, COL_D, String(idx + 1), { align: "center" });
    setCell(ws, row, COL_E, item?.nicCode || "-", { align: "left" });
    setCell(ws, row, COL_F, item?.productName || "-", { align: "left" });
    setCell(ws, row, COL_G, formatPercent(item?.percentageOfTurnover), { align: "center" });
    setCell(ws, row, COL_H, item?.boundary || "-", { align: "left", vertical: "top" });
    setCell(ws, row, COL_I, toYesNo(item?.conductedByExternalAgency), { align: "center" });
    setCell(ws, row, COL_J, toYesNo(item?.resultsPublicDomain), { align: "center" });
    setCell(ws, row, COL_K, item?.webLink || "-", { align: "left" });
  });

  return ws;
}
